import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import Icon from '@userzoomlibraries/toolkit-icon';
import { B as Button } from './index.styled.js';
import { jsx } from 'react/jsx-runtime';

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var buttonPropTypes = Object.keys(Button.propTypes).filter(function (each) {
  return !['children', 'leftIcon', 'rightIcon'].includes(each);
}).reduce(function (acc, current) {
  return _objectSpread$1(_objectSpread$1({}, acc), {}, _defineProperty$1({}, current, Button.propTypes[current]));
}, {});
var buttonDefaultProps = Object.keys(Button.defaultProps).filter(function (each) {
  return !['children', 'leftIcon', 'rightIcon'].includes(each);
}).reduce(function (acc, current) {
  return _objectSpread$1(_objectSpread$1({}, acc), {}, _defineProperty$1({}, current, Button.defaultProps[current]));
}, {});
var iconPropTypes = Object.keys(Icon.propTypes).filter(function (each) {
  return !['id'].includes(each);
}).reduce(function (acc, current) {
  return _objectSpread$1(_objectSpread$1({}, acc), {}, _defineProperty$1({}, current, Icon.propTypes[current]));
}, {});
var iconDefaultProps = Object.keys(Icon.defaultProps).filter(function (each) {
  return !['id'].includes(each);
}).reduce(function (acc, current) {
  return _objectSpread$1(_objectSpread$1({}, acc), {}, _defineProperty$1({}, current, Icon.defaultProps[current]));
}, {});

var _excluded = ["className", "name", "fallback"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var IconButton$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      fallback = _ref.fallback,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({
    ref: ref,
    className: "gz-icon-button ".concat(className)
  }, rest), {}, {
    children: /*#__PURE__*/jsx(Icon, {
      className: "gz-icon-button__icon",
      name: name,
      fallback: fallback
    })
  }));
});
IconButton$1.COMPONENT_ID = 'Gearz.IconButton';
IconButton$1.displayName = IconButton$1.COMPONENT_ID;
IconButton$1.propTypes = _objectSpread(_objectSpread({}, buttonPropTypes), iconPropTypes);
IconButton$1.defaultProps = _objectSpread(_objectSpread({}, buttonDefaultProps), iconDefaultProps);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var IconButton = styled(IconButton$1).withConfig({
  componentId: "gz-button-1679041998923__sc-1wiqwat-0"
})(["", ""], function (props) {
  return getThemeByProps({
    componentId: IconButton$1.COMPONENT_ID,
    props: props
  });
});
IconButton.displayName = IconButton$1.displayName;
IconButton.propTypes = IconButton$1.propTypes;
IconButton.defaultProps = IconButton$1.defaultProps;

export { IconButton as I };
